<div class="list-item" [ngClass]="{'disabled': disabled}" (click)="raiseSelectEvent()" [style.margin-top]="marginTop + 'px'">
    <ng-content></ng-content>
</div>